import { NodoEstructuraJerarquica } from './nodo-estructura-jerarquica.model';
import { Evaluacion } from './evaluacion.model';
import { DocumentoDeIdentidad } from './documento-de-identidad.model';
import { Contacto } from './contacto.model';


export class Usuario
{
    nombre: string;
    segundoNombre: string;
    apellido: string;
    segundoApellido: string;
    imagen: string;
    correoElectronico: string;
    nombreCompleto: string;
    password: string;
    active: number;
    tipos: any[];
    id: number;
    estructuras: NodoEstructuraJerarquica[];
    evaluaciones: Evaluacion[];
    documentoIdentidad: DocumentoDeIdentidad;
    contacto: Contacto;

    /**
     * Constructor
     *
     * @param usuario
     */
    constructor(usuario)
    {
        {
            this.id = usuario.id || null;
            this.nombre = usuario.nombre || '';
            this.segundoNombre = usuario.segundoNombre || '';
            this.apellido = usuario.apellido || '';
            this.segundoApellido = usuario.segundoApellido || '';
            this.imagen = usuario.imagen || 'assets/images/avatars/profile.jpg';
            this.correoElectronico = usuario.correoElectronico || '';
            this.password = usuario.password || '';
            this.active = usuario.active || 0;
            this.tipos = usuario.tipo || usuario.tipos || [];
            this.nombreCompleto = usuario.nombreCompleto || '';
            this.estructuras = usuario.estructuras || [];
            this.evaluaciones = usuario.evaluaciones || [];
            this.documentoIdentidad = usuario.documentoDeIdentidad;
            this.contacto = usuario.contactos;
        }
    }
}
